import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestBase } from './request-base';

@Injectable()
export class KIDefinitionService extends RequestBase {
    BasePath = 'api/kidefinition';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    GetKIDefinitions(capability?: string): Observable<any[]> {
        const url = capability
            ? this.API_BASE_URL + this.BasePath + '/GetKIDefinitions?capability=' + encodeURIComponent(capability)
            : this.API_BASE_URL + this.BasePath + '/GetKIDefinitions';
        return this.http.get<any[]>(url, this.options);
    }

    LoadKIDefinition(id): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/LoadKIDefinition?id=' + id, this.options);
    }

    SaveKIDefinition(def): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + '/SaveKIDefinition', def, this.options);
    }

    DeleteKIDefinition(id): Observable<any[]> {
        return this.http.delete<any[]>(this.API_BASE_URL + this.BasePath + '/DeleteKIDefinition?id=' + id, this.options);
    }

    GetKITypes(capability?: string): Observable<any[]> {
        const url = capability
            ? this.API_BASE_URL + this.BasePath + '/GetKITypes?capability=' + encodeURIComponent(capability)
            : this.API_BASE_URL + this.BasePath + '/GetKITypes';
        return this.http.get<any[]>(url, this.options);
    }

    GetKIModels(id): Observable<any[]> {
        return this.http.get<any[]>(this.API_BASE_URL + this.BasePath + '/GetKIModels?id=' + id, this.options);
    }
}
